/**
 * API base URL for backend requests.
 * Set NEXT_PUBLIC_BASE_URL_LOCAL in .env.local (e.g. http://localhost:4000) to point the
 * storefront at a local API while NEXT_PUBLIC_BASE_URL stays staging/production.
 */
export function getApiBaseUrl() {
  if (typeof process !== "undefined") {
    const base = process.env.NEXT_PUBLIC_BASE_URL;
    if (base && typeof base === "string") return base.replace(/\/$/, "");
  }
  return "";
}

/**
 * Backend origin for Next.js API route proxies (chatbot, /api/products, /api/artisans).
 * Same resolution as client/server calls that use getApiBaseUrl() + NEXT_PUBLIC_BASE_URL
 * (see utils/productAiListingApi.js). Do not hardcode a port here.
 */
export function getBackendProxyBaseUrl() {
  const local = getApiBaseUrl();
  if (local) return local;
  if (typeof process !== "undefined" && process.env.NEXT_PUBLIC_BASE_URL) {
    return String(process.env.NEXT_PUBLIC_BASE_URL).replace(/\/$/, "");
  }
  return "http://localhost:3100";
}
